import { useCallback } from 'react';

import NotesHeader from './components/NotesHeader';
import NotesSection from './components/NotesSection';
import NotesListBase from './components/NotesList';
import useNotesForAnchor from './hooks/useNotesForAnchor';

const Header = () => <NotesHeader title="Section Notes" />;

/**
 * Displays the Notes for a Section.
 */
const SectionNotes = ({ sectionId }) => {
  const notes = useNotesForAnchor(sectionId);

  const NotesList = useCallback(() => <NotesListBase notes={notes} />, [notes]);

  return (
    <NotesSection anchorId={sectionId} NotesList={NotesList} Header={Header} />
  );
};

export default SectionNotes;
